const sortButton = document.querySelectorAll('.sort__button');
const sortDropdown = document.querySelectorAll('.sort__dropdown')

sortButton.forEach((item, index) => {
  item.addEventListener('click', (e) => {
    e.cancelBubble = true;
    e.currentTarget.classList.toggle('sort__button_active');
  })
  
  window.addEventListener('click', () => {
    item.classList.remove('sort__button_active')
  })
  
  sortDropdown[index].addEventListener('click', (e) => {
    if (e.target.classList.contains('sort__item-button')) {
      item.innerHTML = e.target.parentElement.textContent + '&nbsp;' + e.target.innerHTML;
      document.querySelectorAll('.sort__item-button').forEach(item => {
        item.classList.remove('sort__item-button_active')
      })
      e.target.classList.add('sort__item-button_active');
    }
  })

})
